import React from 'react';
import JournalNavigation from '../../components/JournalNavigation';

const Progress = () => {
    return (
        <div className="journal-page">
            <h1>Progress Tracking</h1>
            <p className="subtitle">Visualize your health journey</p>

            <div className="card" style={{ marginTop: '24px' }}>
                <h2>Coming Soon</h2>
                <p>This section will include charts and visualizations of your progress over time.</p>
            </div>

            <JournalNavigation
                prevPage="/journal/transformation"
                nextPage="/journal/checkin-01"
            />
        </div>
    );
};

export default Progress;
